(() => {
  if (window.__p4mF16MatchingSetReady === true) return;
  window.__p4mF16MatchingSetReady = true;

  const productCache = new Map();
  const pendingKey = 'p4m_f16_matching_set_pending';

  const publish = (name, payload = {}) => {
    const detail = { interaction: payload.interaction || name, ...payload };
    if (window.P4MFunnel && typeof window.P4MFunnel.publish === 'function') {
      window.P4MFunnel.publish(name, detail);
      return;
    }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
    try {
      window.Shopify?.analytics?.publish?.(name, detail);
    } catch (_error) {
      return;
    }
  };

  const fetchProduct = async (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        headers: { accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error(`Product read failed (${response.status})`);
        return response.json();
      }));
    }
    return productCache.get(handle);
  };

  const selectedVariantId = (root) => {
    const section = root.closest('.shopify-section') || document;
    const input = section.querySelector('product-form-component input[name="id"], product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input?.value) return String(input.value);
    return new URL(window.location.href).searchParams.get('variant') || '';
  };

  const productImageUrl = (product, variant) => {
    return variant?.featured_image?.src || variant?.featured_image || product?.featured_image || product?.images?.[0] || '';
  };

  const syncPdpKit = async (root) => {
    if (root.dataset.p4mF16Context !== 'pdp') return;
    const currentHandle = root.dataset.p4mF16CurrentHandle || '';
    if (!currentHandle) return;

    try {
      const section = root.closest('.shopify-section') || document;
      const checkedColor = Array.from(section.querySelectorAll('input[type="radio"]:checked')).find((input) => /colou?r/i.test(input.name || ''));
      let selectedColor = String(checkedColor?.value || '').trim();
      if (!selectedColor) {
        const currentProduct = await fetchProduct(currentHandle);
        const variantId = selectedVariantId(root);
        const currentVariant = currentProduct.variants?.find((variant) => String(variant.id) === variantId)
          || currentProduct.variants?.find((variant) => variant.available)
          || currentProduct.variants?.[0];
        selectedColor = String(currentVariant?.options?.[0] || '').trim();
      }
      if (!selectedColor) return;

      const copy = root.querySelector('[data-p4m-f16-color-copy]');
      if (copy) copy.innerHTML = `Matched to <strong>${escapeHtml(selectedColor)}</strong>. Choose the right size on each piece.`;

      await Promise.all(Array.from(root.querySelectorAll('[data-p4m-f16-card]')).map(async (card) => {
        const handle = card.dataset.p4mF16TargetHandle || '';
        if (!handle) return;
        const targetProduct = await fetchProduct(handle);
        const targetVariant = targetProduct.variants?.find((variant) => {
          return variant.available && String(variant.options?.[0] || '').trim().toLowerCase() === selectedColor.toLowerCase();
        }) || targetProduct.variants?.find((variant) => variant.available) || targetProduct.variants?.[0];
        if (!targetVariant) return;

        const href = `/products/${encodeURIComponent(handle)}?variant=${encodeURIComponent(targetVariant.id)}`;
        card.querySelectorAll('[data-p4m-f16-item-link]').forEach((link) => link.setAttribute('href', href));
        const image = card.querySelector('[data-p4m-f16-item-image]');
        const nextImage = productImageUrl(targetProduct, targetVariant);
        if (image && nextImage && image.src !== nextImage) {
          image.src = nextImage;
          image.removeAttribute('srcset');
        }
        const label = card.querySelector('[data-p4m-f16-match-label]');
        if (label) label.textContent = String(targetVariant.options?.[0] || '').trim() === selectedColor ? 'Matching color' : 'Available';
      }));
    } catch (_error) {
      return;
    }
  };

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const initRoot = (root) => {
    if (root.dataset.p4mF16Ready === 'true') return;
    root.dataset.p4mF16Ready = 'true';

    root.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-p4m-f16-item-link]');
      if (!link) return;
      const card = link.closest('[data-p4m-f16-card]');
      const targetHandle = card?.dataset.p4mF16TargetHandle || '';
      const sourceHandle = root.dataset.p4mF16CurrentHandle || 'search';
      publish('p4m_matching_set_item_opened', {
        interaction: 'matching_set_item_opened',
        context: root.dataset.p4mF16Context || '',
        source_handle: sourceHandle,
        target_handle: targetHandle
      });
      try {
        sessionStorage.setItem(pendingKey, JSON.stringify({ sourceHandle, targetHandle, storedAt: Date.now() }));
      } catch (_error) {
        return;
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        publish('p4m_matching_set_viewed', {
          interaction: 'matching_set_viewed',
          context: root.dataset.p4mF16Context || '',
          source_handle: root.dataset.p4mF16CurrentHandle || 'search'
        });
        observer.disconnect();
      }, { threshold: 0.35 });
      observer.observe(root);
    }

    syncPdpKit(root);
  };

  const initAll = () => document.querySelectorAll('[data-p4m-f16-kit]').forEach(initRoot);
  let syncTimer = 0;
  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      document.querySelectorAll('[data-p4m-f16-kit][data-p4m-f16-context="pdp"]').forEach(syncPdpKit);
    }, 120);
  };

  initAll();
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio') scheduleSync();
  });
  document.addEventListener('theme:variant:change', scheduleSync);
  document.addEventListener('variant:update', scheduleSync);
  document.addEventListener('shopify:section:load', () => { initAll(); scheduleSync(); });

  const publishPendingAdd = () => {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending?.targetHandle || Date.now() - Number(pending.storedAt || 0) > 30 * 60 * 1000) return;
      publish('p4m_matching_set_add', {
        interaction: 'matching_set_add',
        source_handle: pending.sourceHandle || '',
        target_handle: pending.targetHandle
      });
      sessionStorage.removeItem(pendingKey);
    } catch (_error) {
      return;
    }
  };
  document.addEventListener('cart:update', publishPendingAdd);
  document.addEventListener('cart:refresh', publishPendingAdd);
})();
